@if (ss.branding | async) {
  <a [href]="'https://' + (ss.branding | async).domain" target="_blank" class="z-promo-container">
    <span [class.z-underline]="ss.isBasic | async" [style.color]="(ss.colors | async).text80">
      {{ 'You answered an intelligent Zeffi survey' | translateText: 'promoTextZef' }}
    </span>
    @if (ss.isFree | async) {
      <span class="z-underline" [style.color]="(ss.colors | async).primary">
        {{ 'Create your own survey, fast!' | translateText: 'promoTextLink' }}
      </span>
    }
  </a>
}
